import React, { useContext, useEffect, useRef, useState } from "react";
import { json, useNavigate } from "react-router-dom";
import { CompanyContext } from "../contexts/companyCotext";
import buildLink from "../urls";
import axios from "axios";
import MessageAlert from "../components/messageAlert";

function SerialNumber() {
    const history = useNavigate();
    const [state, dispatch] = useContext(CompanyContext);
    const serialNum = useRef("");
    const [showMessgSucc, setShowMessageSucc] = useState(false);
    const [message, setMessage] = useState("");
    const [showMessgErr, setShowMessageErr] = useState(false);
    const [host, setHost] = useState(window.location.host);
  
    useEffect(() => {
      setHost(window.location.host);
    }, [host]);

    async function serialNumber(e) {
        e.preventDefault();
        const serial_number = serialNum.current.value;
        const obj = {
            serial_number
        };
        try {
          await axios.post(buildLink("checkSerialNumber"), obj).then((response) => {
     
            if (response.data.success == true) {
              history("/login", { replace: true });
             localStorage.setItem('device_info', JSON.stringify(response.data.data));
            
            }
          });
        } catch (e) {
          setMessage(e.response.data.message);
          setShowMessageErr(true);
        }
     
      }


  return (
    <div className=" h-full bg-white">
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative flex-row justify-between  w-full text-white  h-full my-auto">
              <h2 className=" text-xl    my-auto"> {state.company} </h2>
            </div>
          </div>
        </div>
        <div className=" container  flex flex-col justify-center gap-5 text-center ">
          <form className=" flex flex-col gap-4" onSubmit={(e) => serialNumber(e)}>
            <input
              ref={serialNum}
              type="text"
              className=" border-dlabelColor  border px-3 py-3 rounded-md"
              placeholder="Enter Serial Number"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    serialNumber(e);
                }
              }}
            />
          
            {/* <button
              type="submit"
              onClick={(e) => {
                serialNumber(e);
              }}
              className=" bg-dbase  px-3 py-3 text-white rounded-sm mt-3"
            >
              {" "}
              {loading ? "loading..." : "Submit"}
            </button> */}
          </form>
        </div>
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
  )
}

export default SerialNumber
